import '../css/app.css';
import './bootstrap';

import * as Sentry from '@sentry/vue';
import { createInertiaApp, router } from '@inertiajs/vue3';
import { resolvePageComponent } from 'laravel-vite-plugin/inertia-helpers';
import { createApp, DefineComponent, h } from 'vue';
import { ZiggyVue } from '../../vendor/tightenco/ziggy';
import { installTranslate } from './Plugins/translate';

const appName = import.meta.env.VITE_APP_NAME || 'Mikes Garage';

createInertiaApp({
    title: (title) => `${title} - ${appName}`,
    resolve: (name) =>
        resolvePageComponent(
            `./Pages/${name}.vue`,
            import.meta.glob<DefineComponent>('./Pages/**/*.vue'),
        ),
    setup({ el, App, props, plugin }) {
        const app = createApp({ render: () => h(App, props) })
            .use(plugin)
            .use(ZiggyVue);

        installTranslate(app, props.initialPage.props);

        if (import.meta.env.VITE_SENTRY_DSN_PUBLIC) {
            Sentry.init({
                app,
                dsn: import.meta.env.VITE_SENTRY_DSN_PUBLIC,
                integrations: [
                    Sentry.browserTracingIntegration(),
                ],
                tracesSampleRate: 0.1,
                environment: import.meta.env.MODE,
                tracePropagationTargets: [window.location.hostname],
            });

            router.on('navigate', () => {
                Sentry.getCurrentScope().setTransactionName(window.location.pathname);
            });
        }

        app.mount(el);
    },
    progress: {
        color: '#4B5563',
    },
});
